import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { currentDate } from '../../../core/helper';
import { DEFAULT_INSTITUTIONAL_WEBSITE_URL, DEFAULT_PRIVACY_POLICY_URL, DEFAULT_TERMS_OF_USE_URL } from '../../../core/constants';


export const Footer = () => {
    const systemCheck = useSelector(state => state?.systemCheck?.data?.data);
    const privacyPolicyUrl = systemCheck?.privacy_policy_url || DEFAULT_PRIVACY_POLICY_URL;
    const termsOfUseUrl = systemCheck?.terms_of_use_url || DEFAULT_TERMS_OF_USE_URL;
    const institutionalWebsiteUrl = systemCheck?.institutional_website_url || DEFAULT_INSTITUTIONAL_WEBSITE_URL;

    const [dateNow, setDateNow] = useState(null);

    useEffect(() => {
        setDateNow(currentDate());
    }, []);

    return (

        <footer className="text-muted d-md-flex justify-content-between text-center text-md-left">
            <div>
                <Link to="/contact-us" className="text-muted d-block d-md-inline pl-0">Contact Us</Link>|
                <a href={institutionalWebsiteUrl} rel="noopener noreferrer" target="_blank" className="text-muted">About True Talent Labs</a>|

                {/* <Link to="/privacy" className="text-muted welcome-link mr-5">Privacy</Link> */}
                <a href={privacyPolicyUrl} rel="noopener noreferrer" className="text-muted d-block d-md-inline" target='_blank'>Privacy Policy</a>|
                <a href={termsOfUseUrl} rel="noopener noreferrer" className="text-muted d-block d-md-inline" target='_blank'>Terms of Use</a>
            </div>

            <p className='mb-0'>Copyright True Leadership Solutions LLC. {dateNow}. All rights reserved.</p>
        </footer>

    )
}